import React from 'react';

export const FcTableResult = ({ count, mapper }: FcTableResultProps) => {
  if (!count) return null;

  return <span className={'text-sm text-[#666]'}>+ {mapper(count)}</span>;
};

interface FcTableResultProps {
  mapper: (count: number) => string;
  count?: number;
}